import {AlpineComponent} from 'alpinejs';
import {Loader} from 'google-maps';

type ContactHeroData = {
  googleMapApiKey: string
  initMap: () => void,
}

export default (): AlpineComponent<ContactHeroData> => ({
  googleMapApiKey: 'AIzaSyBbqbbi4hq6zZ6sHhZCrnqQ4F06r0ljmB0',
  init() {
    const loader = new Loader(this.googleMapApiKey);
    loader.load()
      .then(() => {
        this.initMap();
      })
      .catch(e => {
        throw new Error(`Error loading Google Map ${e.message}`);
      });
  },
  async initMap() {
    const mapEl = this.$refs.map;
    const mapContent = this.$refs.mapContent;
    const latitude = mapEl ? Number(mapEl.getAttribute('data-map-latitude')) : false;
    const longitude = mapEl ? Number(mapEl.getAttribute('data-map-longitude')) : false;

    if (mapEl && latitude && longitude) {
      const map = new google.maps.Map(mapEl, {
        center: {lat: latitude, lng: longitude},
        zoom: 16,
        disableDefaultUI: true
      });

      class Popup extends google.maps.OverlayView {
        position: google.maps.LatLng;
        containerDiv: HTMLDivElement;

        constructor(position: google.maps.LatLng, content: HTMLElement) {
          super();
          this.position = position;

          // This zero-height div is positioned at the bottom of the bubble.
          const bubbleAnchor = document.createElement('div');

          bubbleAnchor.classList.add('ce-contact-hero-map-box-wrapper');
          bubbleAnchor.appendChild(content);

          // This zero-height div is positioned at the bottom of the tip.
          this.containerDiv = document.createElement('div');
          this.containerDiv.classList.add('ce-contact-hero-map-box-container');
          this.containerDiv.appendChild(bubbleAnchor);

          // Optionally stop clicks, etc., from bubbling up to the map.
          Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
        }

        // Called when the popup is added to the map
        onAdd() {
          this.getPanes()!.floatPane.appendChild(this.containerDiv);
        }

        // Called when the popup is removed from the map
        onRemove() {
          if (this.containerDiv.parentElement) {
            this.containerDiv.parentElement.removeChild(this.containerDiv);
          }
        }

        // Called each frame when the popup needs to draw itself
        draw() {
          const divPosition = this.getProjection().fromLatLngToDivPixel(
            this.position
          )!;

          // Hide the popup when it is far out of view.
          const display =
            Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
              ? 'block'
              : 'none';

          if (display === 'block') {
            this.containerDiv.style.left = divPosition.x + 'px';
            this.containerDiv.style.top = divPosition.y + 'px';
          }

          if (this.containerDiv.style.display !== display) {
            this.containerDiv.style.display = display;
          }
        }
      }

      const popupInstance = new Popup(
        new google.maps.LatLng(latitude, longitude),
        mapContent as HTMLElement
      );
      popupInstance.setMap(map);
    }
  }
});
